/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{color:#212529;display:block;-webkit-margin-before:.83em;margin-block-start:.83em;-webkit-margin-after:.83em;margin-block-end:.83em}h2[_ngcontent-%COMP%]{display:inline;margin-right:10px}.rating[_ngcontent-%COMP%]{font-size:18pt;display:inline}.rating[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#fed33c}.rating[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-right:15px}"];
export { styles as styles };
